export const navItems = [
  { name: "Home", key: "home", path: "/" },
  { name: "Analytics", key: "Analytics", path: "/analytics" },
  { name: "Mood Analysis", key: "mood", path: "/mood" },
  { name: "Grievance", key: "grievance", path: "/grievances" },
];
